import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/icon';
import Tooltip from 'components/tooltip';
import Loading from 'components/loading';
import AsyncUploadAppStatus from 'components/apps/async-upload-status';
import { classNames } from 'utils';

export default class StorefrontPreviewImage extends React.PureComponent {
  static propTypes = {
    app: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onCompletedAsync: PropTypes.func,
    styleAssets: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    mobile: PropTypes.bool,
  };

  render() {
    const {
      app,
      onClick,
      onCompletedAsync,
      styleAssets,
      width,
      height,
      mobile,
    } = this.props;
    const { name, theme, preview_theme, async_error, async_progressing } = app;

    const previewImage = styleAssets?.preview_image || app.preview_image;
    const previewImageMobile =
      styleAssets?.preview_mobile_image || app.preview_mobile_image;
    const previewThumbnails = preview_theme?.preview_thumbnails;

    const url = previewImage?.url
      ? `${previewImage.url}?anchor=top${width ? `&width=${width}` : ''}`
      : previewThumbnails?.desktop;

    const mobileUrl =
      mobile && previewImageMobile?.url
        ? `${previewImageMobile.url}?anchor=top${
            width ? `&width=${width / 3}` : ''
          }`
        : previewThumbnails?.mobile;

    const isShopify = theme?.storefront?.compatibility?.shopify;

    return (
      <div
        className={classNames('storefront-apps-preview-image', {
          clickable: Boolean(onClick),
          empty: !url,
        })}
        onClick={onClick}
        style={{
          width,
          height,
        }}
      >
        {async_error ? (
          <Tooltip message={async_error}>
            <Icon fa="exclamation-triangle" faType="light" />
          </Tooltip>
        ) : async_progressing ? (
          <AsyncUploadAppStatus app={app} onCompleted={onCompletedAsync} />
        ) : previewThumbnails?.loading ? (
          <div className="loading-async-task">
            <Loading size={16} />
            Generating preview
          </div>
        ) : url ? (
          <>
            <div className="storefront-apps-preview-image-desktop">
              <img src={url} alt={name} className="desktop" />
            </div>
            {mobileUrl && (
              <div className="storefront-apps-preview-image-mobile">
                <img src={mobileUrl} alt={name} className="mobile" />
              </div>
            )}
          </>
        ) : isShopify ? (
          <Icon fa="brands fa-shopify" />
        ) : (
          <Icon fa="display-code" faType="light" />
        )}
      </div>
    );
  }
}
